module.exports = __webpack_public_path__ + "img/1458432247.b163c855.jpg";